import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import SubmissionButton from '~/components/submissionButton/submissionButton';

export const updateTankStatusMutation = gql`
  mutation updateTankStatuses($breweryId: Int!, $status: TankStatus!, $tanks: [TankStatusUpdateType]!) {
    updateTankStatuses(breweryId: $breweryId, status: $status, tanks: $tanks) {
      id
    }
  }
`;

export class MarkTankCleanModal extends Component {
  state = {
    submitting: false
  };

  setSubmitting = submitting => {
    this.setState({
      submitting
    });
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { isOpen, onToggle, onSuccess, brewery, refetchQueries, tanks } = this.props;
    const { submitting, error } = this.state;
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Confirm tanks as cleaned</ModalHeader>
        <Mutation mutation={updateTankStatusMutation}>
          {updateTankStatuses => (
            <Fragment>
              <ModalBody>
                {error && <Alert color="danger">{error}</Alert>}
                <p className="mb3">Do you want to confirm that these tanks have been cleaned?</p>
                <div>
                  {tanks.map(t => (
                    <div key={t.id} className="mb3 pb3 bb-divider">
                      <h4 className="mv0 f5">{t.name}</h4>
                    </div>
                  ))}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={onToggle}>
                  Cancel
                </Button>{' '}
                <SubmissionButton
                  color="primary"
                  isSubmitting={submitting}
                  onClick={async () => {
                    this.setSubmitting(true);

                    try {
                      await updateTankStatuses({
                        variables: {
                          breweryId: brewery.id,
                          status: 'EMPTY',
                          tanks: tanks.map(l => ({
                            id: l.id
                          }))
                        },
                        awaitRefetchQueries: true,
                        refetchQueries
                      });

                      onSuccess();
                    } catch (err) {
                      console.error(err);
                      this.setError('An unknown error occured');
                      this.setSubmitting(false);
                    }
                  }}
                >
                  Confirm
                </SubmissionButton>
              </ModalFooter>
            </Fragment>
          )}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(MarkTankCleanModal);



// WEBPACK FOOTER //
// ./src/containers/markTankCleanModal/markTankCleanModal.jsx